import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Mi hija espera cada cita con ilusión. Nos acercó muchísimo.',
    author: 'María — mamá de 2 hijos',
    stars: 5
  }, {
    quote: 'Nos devolvió momentos que la rutina nos estaba robando.',
    author: 'Lucas — papá',
    stars: 5
  }, {
    quote: 'Ahora tengo actividades listas para compartir con mis hijos sin pensar.',
    author: 'Carolina — mamá',
    stars: 5
  }, {
    quote: 'No es un libro. Es tiempo de calidad real.',
    author: 'Andrea — mamá',
    stars: 5
  }];
  return <section className="py-10 md:py-14 px-4 bg-white" data-id="element-242">
      <div className="max-w-3xl mx-auto" data-id="element-243">
        <div data-id="element-244">
          <div className="text-center mb-10" data-id="element-245">
            <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-246">
              ⭐ LO QUE DICEN LOS PADRES
            </h2>
            <div className="flex justify-center gap-1 mb-3" data-id="element-247">
              {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400 text-2xl md:text-3xl" data-id="element-248">
                  ★
                </span>)}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-249">
            {testimonials.map((t, idx) => <div key={idx} className="bg-gray-50 p-4 rounded-xl border border-gray-200 shadow-sm" data-id="element-250">
                <div className="flex gap-1 mb-2" data-id="element-251">
                  {[...Array(t.stars)].map((_, i) => <span key={i} className="text-yellow-400 text-sm" data-id="element-252">
                      ★
                    </span>)}
                </div>
                <p className="text-gray-800 text-sm md:text-base font-medium italic mb-2" data-id="element-253">
                  "{t.quote}"
                </p>
                <p className="text-xs md:text-sm text-gray-500 font-bold" data-id="element-254">
                  — {t.author}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}